import { directives } from '@zk/framework-vue';
import store from '@/store';
import Vue from 'vue';
import { checkInPermission } from '@/utils/permission';

const { Permission } = directives;
export const doCheckResource = (need, type) => {
  if (need === '*') {
    return true;
  }
  const checkRole = (n) => checkInPermission([n], store.getters['user/roleCodes']);
  if (need.startsWith('role:')) {
    const needRole = need.split(':')[1];
    return checkRole(needRole);
  }
  return type === 'role' ? checkRole(need) : checkInPermission([need], store.getters['user/permissionAsg']);
};
export const checkPermissionOrRole = (type = 'permission') => {
  return (_, need) => {
    if (Array.isArray(need)) {
      return need.every(doCheckResource);
    }
    return doCheckResource(need, type);
  };
};
const permissionDirectives = {
  permission: Permission({
    roles: () => store.getters.allRoles.filter(role => role.enabled === 1),
    checkRole: checkPermissionOrRole('role'),
    permissions: () => {
      const permissions = store.getters['user/permissionAsg'];
      return permissions.length ? permissions : [''];
    },
    checkPermission: checkPermissionOrRole()
  }),
  projectPermission: Permission({
    roles: () => store.getters.projectRoles.filter(role => role.enabled === 1),
    checkRole: (role, need) => need === '*' || role.roleCode === need
  })
};
Vue.prototype.directives = permissionDirectives;

Object.keys(permissionDirectives).forEach(key => {
  Vue.directive(key, permissionDirectives[key]);
});
